"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.depositWUSDC = depositWUSDC;
exports.withdrawWUSDC = withdrawWUSDC;
const callSmartContractFunction_js_1 = require("./callSmartContractFunction.js");
const alphafi_sdk_1 = require("@alphafi/alphafi-sdk");
async function depositWUSDC(context, amount) {
    //let amountToDeposit = amount;
    // Handle string input by attempting to parse it as a number
    if (typeof amount === "string") {
        const parsedAmount = parseFloat(amount);
        if (isNaN(parsedAmount) || parsedAmount <= 0) {
            throw new Error("Invalid amount. Please enter a valid positive number.");
        }
        //amountToDeposit = parsedAmount;
    }
    // convert from amountToDeposit to coinId
    const depositCoinId = "0xQWER";
    const asset = 0;
    const borrow_asset = 5;
    const OPTION = 1;
    const txb = (0, callSmartContractFunction_js_1.prepareTransactionBlock)();
    const args = (0, callSmartContractFunction_js_1.prepareArgs)([
        { value: "0x2::sui::SUI", type: "type" },
        {
            value: `${(0, alphafi_sdk_1.getConf)().ALPHA_LATEST_PACKAGE_ID}::alpha::XSUI`,
            type: "type",
        },
        { value: (0, alphafi_sdk_1.getConf)().ALPHA_WUSDC_POOL, type: "object" },
        { value: (0, alphafi_sdk_1.getConf)().ALPHA_WUSDC_CETUS_INVESTOR, type: "object" },
        { value: (0, alphafi_sdk_1.getConf)().SCALLOP_WUSDC_REWARDS_POOL, type: "object" },
        { value: (0, alphafi_sdk_1.getConf)().SCALLOP_WUSDC_SPOOL, type: "object" },
        { value: (0, alphafi_sdk_1.getConf)().SCALLOP_VERSION, type: "object" },
        { value: (0, alphafi_sdk_1.getConf)().SCALLOP_MARKET, type: "object" },
        { value: depositCoinId, type: "object" },
        { value: (0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID, type: "object" },
        { value: (0, alphafi_sdk_1.getConf)().PRICE_ORACLE, type: "object" },
        { value: (0, alphafi_sdk_1.getConf)().NAVI_STORAGE, type: "object" },
        { value: (0, alphafi_sdk_1.getConf)().NAVI_WUSDC_POOL, type: "object" },
        { value: (0, alphafi_sdk_1.getConf)().NAVI_USDT_BORROW_POOL, type: "object" },
        { value: asset, type: "u8" },
        { value: borrow_asset, type: "u8" },
        { value: (0, alphafi_sdk_1.getConf)().NAVI_INCENTIVE_V1, type: "object" },
        { value: (0, alphafi_sdk_1.getConf)().NAVI_INCENTIVE_V2, type: "object" },
        { value: (0, alphafi_sdk_1.getConf)().NAVI_VSUI_FUNDS_POOL, type: "object" },
        { value: OPTION, type: "u8" },
    ], txb);
    await (0, callSmartContractFunction_js_1.executeFunction)(context, `${(0, alphafi_sdk_1.getConf)().ALPHA_LATEST_PACKAGE_ID}::pool::user_deposit`, args, txb);
}
async function withdrawWUSDC(context, amount) {
    //let amountToWithdraw = amount;
    if (amount !== "all" && typeof amount === "string") {
        const parsedAmount = parseFloat(amount);
        if (isNaN(parsedAmount)) {
            throw new Error("Invalid amount. Please enter a valid number or 'all'.");
        }
        //amountToWithdraw = parsedAmount;
    }
    const withdrawCoinId = "0xASDF";
    const asset = 0;
    const borrow_asset = 5;
    const OPTION = 1;
    const txb = (0, callSmartContractFunction_js_1.prepareTransactionBlock)();
    const args = (0, callSmartContractFunction_js_1.prepareArgs)([
        { value: "0x2::sui::SUI", type: "type" },
        {
            value: `${(0, alphafi_sdk_1.getConf)().ALPHA_LATEST_PACKAGE_ID}::alpha::XSUI`,
            type: "type",
        },
        { value: (0, alphafi_sdk_1.getConf)().ALPHA_WUSDC_POOL, type: "object" },
        { value: (0, alphafi_sdk_1.getConf)().ALPHA_WUSDC_CETUS_INVESTOR, type: "object" },
        { value: (0, alphafi_sdk_1.getConf)().SCALLOP_WUSDC_REWARDS_POOL, type: "object" },
        { value: (0, alphafi_sdk_1.getConf)().SCALLOP_WUSDC_SPOOL, type: "object" },
        { value: (0, alphafi_sdk_1.getConf)().SCALLOP_VERSION, type: "object" },
        { value: (0, alphafi_sdk_1.getConf)().SCALLOP_MARKET, type: "object" },
        { value: withdrawCoinId, type: "object" },
        { value: (0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID, type: "object" },
        { value: (0, alphafi_sdk_1.getConf)().PRICE_ORACLE, type: "object" },
        { value: (0, alphafi_sdk_1.getConf)().NAVI_STORAGE, type: "object" },
        { value: (0, alphafi_sdk_1.getConf)().NAVI_WUSDC_POOL, type: "object" },
        { value: (0, alphafi_sdk_1.getConf)().NAVI_VSUI_BORROW_POOL, type: "object" },
        { value: asset, type: "u8" },
        { value: borrow_asset, type: "u8" },
        { value: (0, alphafi_sdk_1.getConf)().NAVI_INCENTIVE_V1, type: "object" },
        { value: (0, alphafi_sdk_1.getConf)().NAVI_INCENTIVE_V2, type: "object" },
        { value: (0, alphafi_sdk_1.getConf)().NAVI_VSUI_FUNDS_POOL, type: "object" },
        { value: OPTION, type: "u8" },
    ], txb);
    await (0, callSmartContractFunction_js_1.executeFunction)(context, `${(0, alphafi_sdk_1.getConf)().ALPHA_LATEST_PACKAGE_ID}::pool::user_deposit`, args, txb);
}
//# sourceMappingURL=usdc.js.map